import { ReactNode, CSSProperties, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './PopOver.module.scss';

type PopOverProps = {
  children: ReactNode;
  style: CSSProperties; // Optional style to prevent undefined errors
};

// Wrap PopOver with forwardRef
const PopOver = forwardRef<HTMLDivElement, PopOverProps>(({ children, style }, ref) => {
  const popOverElement = document.getElementById('popovers') || document.body;
  return ReactDOM.createPortal(
    <div ref={ref} className={styles.popOverContainer} style={style}>
      <div className={styles.popOverElement}>
        <div className={styles.popOverChildren}>{children}</div>
      </div>
    </div>,
    popOverElement,
  );
});

PopOver.displayName = 'PopOver';

export default PopOver;
